import * as sites from './list'

export const allSites = Object.values(sites).sort((previous, current) =>
    previous.name.localeCompare(current.name),
)
